import * as d3 from 'd3'
export default {
  methods: {

    draw_dataValues() {
      let lineHeight = this.values.lineHeight
      let subtotal = this.groups.subTotal

      let dataTable = d3.select(`#CANVAS_CONTENTS_${this.localId}`)
      .append('g')
      .attr('transform', `translate(${this.groups.width}, ${0})`)

      let groupLen = this.groups.columns.length
      let lastIdx = this.dataSet.length -1
      let y_ = 0

      this.dataSet.forEach((d,i)=> {

        this.values.columns.forEach(col=> {

          if(this.tDisplay && d.overall) {
            dataTable // Background Color
            .append('rect')
            .attr('x', col.sx).attr('y', y_)
            .attr('width', col.width).attr('height', (lastIdx==i) ? lineHeight + 1 : lineHeight)
            .attr('fill', subtotal.bgColor).attr('opacity', subtotal.opacity[d.overallCount-1])
          }
          if(col.type == 'PROG') {
            this.gmx_ProgressBar(
              dataTable, 
              col.sx + 4.5, y_ + (lineHeight/2) + .5, 
              d[col.code], this.values.tSize, col.tColor,
              col.bar,
            )
          } else {
            dataTable
            .append('text')
            .attr('x', col.tx)
            .attr('y', (this.tDisplay && lastIdx==i) ? y_ + (lineHeight/2) + ((this.tDisplay && lastIdx==i) ? this.values.tSize + .5 : this.values.tSize)*0.4 : y_ + (lineHeight/2) + ((this.tDisplay && lastIdx==i) ? this.values.tSize + .5 : this.values.tSize)*0.36)
            .attr('font-size', (this.tDisplay && lastIdx==i) ? this.values.tSize + .5 : this.values.tSize)
            .attr('fill', ()=> {
              let color = ''
              color = (this.tDisplay && d.overall) ? subtotal.tColor : col.tColor
              if (col.type =='DELTA') color = this.gmx_deltaValue(d[col.code])
              return color
            })
            .attr('text-anchor', col.align)
            .text(this.gmx_numFormat(d[col.code], col.unit))
            .call(this.event_Link, this.nativeData[i], col)
          }

          if(this.header.exxon != 'Y') {
            dataTable
            .append('line') // Vertical Line
            .attr('x1', col.sx).attr('y1', y_)
            .attr('x2', col.sx).attr('y2', (this.tDisplay && lastIdx==i) ? y_ + lineHeight + 2 : y_ + lineHeight)
            .attr('stroke', col.stroke).attr('stroke-width', .5)
          }
        })

        if(i>0) {
          dataTable
          .append('line') // Horizontal Line
          .attr('x1', 0).attr('y1', y_)
          .attr('x2', this.values.width).attr('y2', y_)
          .attr('stroke', d.hStroke).attr('stroke-width', .5)
          .attr('opacity', ()=> {
            let val = 1
            if(groupLen==1) {
              if(this.tDisplay) val = (i==lastIdx) ? 1 : 0.3
              else val = 0.3
            }  
            return val
          })
        }
        

        y_ = y_ + lineHeight
        if(this.tDisplay && lastIdx==i) y_ = y_ + 2
      })

      dataTable
      .append('line') // Last Horizontal Line
      .attr('x1', 0).attr('x2', this.values.width).attr('y1', y_ ).attr('y2', y_)
      .attr('stroke', this.groups.columns[0].stroke).attr('stroke-width', .5)

      if(this.header.lineFL != 'Y') {
        //
      } else {
        dataTable
        .append('line') // Last  Vertical Line
        .attr('x1', this.values.width).attr('x2', this.values.width).attr('y1', -this.header.height).attr('y2', y_)
        .attr('stroke', this.groups.columns[0].stroke).attr('stroke-width', .5)
      }
    },

    
  }
}